// @ts-check
import { withTransistors } from './transistors.js';
import { expandRoute } from './levels/expansion.js';
import { CYBERSPACE } from './levels/cyberspace.js';
import { RELAY, UPPER_BUS, BOOT_GATE } from './levels/boot.js';
import { PACKET_LEVELS } from './levels/packet.js';
import { MEMORY_LEVELS } from './levels/memory.js';
import { CLOCK_LEVELS } from './levels/clock.js';
import { RENDER_LEVELS } from './levels/render.js';
import { THERMAL_LEVELS } from './levels/thermal.js';
import { SECURITY_LEVELS } from './levels/security.js';
import { KERNEL_LEVELS } from './levels/kernel.js';

export const WORLDS = Object.freeze([
  { id: 1, name: 'Boot Sector', system: 'Initialize the signal', motif: 'socket', boss: 'Gatekeeper' },
  { id: 2, name: 'Packet Highway', system: 'Route the traffic', motif: 'lanes', boss: 'Switchboard' },
  { id: 3, name: 'Memory Banks', system: 'Reclaim the missing cells', motif: 'cells', boss: 'Reclaimer' },
  { id: 4, name: 'Clock Domain', system: 'Synchronize the machine', motif: 'clock', boss: 'Clockwarden' },
  { id: 5, name: 'Render Grid', system: 'Assemble the geometry', motif: 'raster', boss: 'Raster' },
  { id: 6, name: 'Thermal Core', system: 'Restore the cooling', motif: 'fins', boss: 'Heatsink' },
  { id: 7, name: 'Security Layer', system: 'Outwit the protection', motif: 'shields', boss: 'Watchdog' },
  { id: 8, name: 'Kernel', system: 'Bring the systems together', motif: 'kernel', boss: 'NULL' },
].map(world => Object.freeze(world)));
export const CAMPAIGN = Object.freeze([
  Object.freeze({ ...CYBERSPACE, world: 1, stage: 1 }), RELAY, UPPER_BUS, BOOT_GATE,
  ...PACKET_LEVELS, ...MEMORY_LEVELS, ...CLOCK_LEVELS, ...RENDER_LEVELS, ...THERMAL_LEVELS, ...SECURITY_LEVELS, ...KERNEL_LEVELS,
].map(expandRoute).map(withTransistors));
